export const PROVIDERS = {
  ADSGRAM: "adsgram",
  BARZHA: "barzha",
  TADS: "tads",
  FLYER: "flyer",
  TAPPADS: "tappads",
  ONCLICK: "onclick",
  ADEXTRA: "adextra",
  RICHADS: "richads",
  MONETAG: "monetag",
  ADEXIUM: "adexium",
} as const;
